var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"d":"M23.7,0A23.7,23.7,0,1,0,47.4,23.7,23.7,23.7,0,0,0,23.7,0ZM33.92,19.42c0,.22,0,.44,0,.66A14.62,14.62,0,0,1,11.42,32.4a10.14,10.14,0,0,0,1.23.07A10.32,10.32,0,0,0,19,30.27a5.15,5.15,0,0,1-4.81-3.57,5.23,5.23,0,0,0,1,.09,5.13,5.13,0,0,0,1.36-.18,5.14,5.14,0,0,1-4.13-5v-.06a5.23,5.23,0,0,0,2.33.64,5.13,5.13,0,0,1-1.59-6.86,14.58,14.58,0,0,0,10.6,5.37,5.06,5.06,0,0,1-.14-1.17A5.15,5.15,0,0,1,32.53,16a10.22,10.22,0,0,0,3.26-1.25,5.17,5.17,0,0,1-2.26,2.85,10.55,10.55,0,0,0,3-.81A10.65,10.65,0,0,1,33.92,19.42Z"}))));
}

Twitter.defaultProps = {"viewBox":"0 0 47.4 47.4"};

module.exports = Twitter;

Twitter.default = Twitter;
